import React, { useState } from 'react';
import { PixelBox, PixelButton, PixelContainer } from '../ui/PixelComponents';
import { useAuth } from '../../context/AuthContext';

export const LoginForm: React.FC<{ onSwitchToRecovery: () => void }> = ({ onSwitchToRecovery }) => {
  const [userNumber, setUserNumber] = useState('');
  const [loginCode, setLoginCode] = useState('');
  const { login, isLoading, error } = useAuth();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      await login(userNumber, loginCode.toLowerCase());
    } catch (error) {}
  };

  return (
    <div
      style={{
        width: '90%',
        maxWidth: '420px',
        margin: '0 auto',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '24px',
        padding: '20px',
      }}
    >
      <div
        style={{
          alignSelf: 'center',
          marginBottom: '20px',
        }}
      >
        <div
          style={{
            backgroundColor: '#000000',
            color: '#FFFFFF',
            borderColor: '#000000',
          }}
        >
          <div
            style={{
              fontSize: '32px',
              fontWeight: 'bold',
              padding: '4px 16px',
            }}
          >
            Ё
          </div>
        </div>
      </div>

      {/* Основная форма */}
      <PixelContainer
        style={{
          padding: '0',
          backgroundColor: '#fff',
        }}
      >
        {/* Контент формы */}
        <div
          style={{
            paddingLeft: '20px',
            paddingRight: '20px',
            paddingTop: '8px',
            paddingBottom: '16px',
          }}
        >
          {/* Заголовок с полосками */}
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              backgroundColor: '#fff',
            }}
          >
            <div
              style={{
                flex: 1,
                height: '3px',
                backgroundColor: '#FFF',
                marginLeft: '8px',
              }}
            ></div>
            <div
              style={{
                padding: '8px 16px',
                fontFamily: 'Tiny5, "Courier New", monospace, sans-serif',
                fontSize: '14px',
                fontWeight: 'bold',
                letterSpacing: '1px',
              }}
            >
              ВХОД
            </div>
            <div
              style={{
                flex: 1,
                height: '3px',
                backgroundColor: '#FFF',
                marginRight: '8px',
              }}
            ></div>
          </div>

          <form onSubmit={handleSubmit}>
            <div
              style={{
                marginBottom: '20px',
                alignItems: 'center',
                justifyContent: 'center',
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              <div
                style={{
                  fontFamily: 'Tiny5, "Courier New", monospace, sans-serif',
                  fontSize: '10px',
                  marginBottom: '6px',
                  color: '#666',
                  textTransform: 'uppercase',
                }}
              >
                Вот твой номер
              </div>
              <PixelContainer
                style={{
                  padding: '0',
                  backgroundColor: '#F0F0F0',
                  placeSelf: 'center',
                }}
              >
                <input
                  type='text'
                  maxLength={8}
                  placeholder='00000000'
                  value={userNumber}
                  onChange={(e) => setUserNumber(e.target.value.replace(/\D/g, ''))}
                  style={{
                    width: '100%',
                    padding: '10px',
                    border: 'none',
                    fontFamily: 'Roboto Mono, monospace',
                    fontSize: '18px',
                    fontWeight: 'bold',
                    letterSpacing: '2px',
                    backgroundColor: 'transparent',
                    textAlign: 'center',
                    outline: 'none',
                  }}
                />
              </PixelContainer>
            </div>

            <div
              style={{
                marginBottom: '20px',
                alignItems: 'center',
                justifyContent: 'center',
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              <div
                style={{
                  fontFamily: 'Tiny5, "Courier New", monospace, sans-serif',
                  fontSize: '10px',
                  marginBottom: '6px',
                  color: '#666',
                  textTransform: 'uppercase',
                }}
              >
                Код для входа
              </div>
              <PixelContainer
                style={{
                  padding: '0',
                  backgroundColor: '#F0F0F0',
                }}
              >
                <input
                  type='text'
                  maxLength={8}
                  placeholder='ABCDEFGH'
                  value={loginCode}
                  onChange={(e) => setLoginCode(e.target.value.toUpperCase())}
                  style={{
                    width: '100%',
                    padding: '10px',
                    border: 'none',
                    fontFamily: 'Roboto Mono, monospace',
                    fontSize: '18px',
                    fontWeight: 'bold',
                    letterSpacing: '2px',
                    backgroundColor: 'transparent',
                    textAlign: 'center',
                    outline: 'none',
                  }}
                />
              </PixelContainer>
            </div>

            {error && (
              <div
                style={{
                  color: '#FF0000',
                  fontFamily: 'Tiny5, "Courier New", monospace, sans-serif',
                  fontSize: '10px',
                  marginBottom: '12px',
                  textAlign: 'center',
                }}
              >
                {error}
              </div>
            )}

            <div
              style={{
                textAlign: 'center',
                marginBottom: '12px',
              }}
            >
              <button
                type='button'
                onClick={onSwitchToRecovery}
                style={{
                  background: 'none',
                  border: 'none',
                  fontFamily: 'Tiny5, "Courier New", monospace, sans-serif',
                  fontSize: '10px',
                  color: '#666',
                  cursor: 'pointer',
                  textDecoration: 'underline',
                  textTransform: 'uppercase',
                }}
              >
                Я забыл, восстановить!
              </button>
            </div>
          </form>
        </div>
      </PixelContainer>

      {/* Кнопка действия */}
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        <PixelButton
          backgroundColor='#C0C0C0'
          borderColor='#000000'
          shadowColor='#808080'
          onClick={handleSubmit}
          disabled={userNumber.length !== 8 || loginCode.length !== 8 || isLoading}
          size='medium'
          style={{
            padding: '12px 32px',
            minWidth: '160px',
          }}
        >
          <div
            style={{
              fontFamily: 'Tiny5, "Courier New", monospace, sans-serif',
              fontSize: '18px',
              fontWeight: 'bold',
              letterSpacing: '1px',
            }}
          >
            {isLoading ? 'ВХОД...' : 'В ЧАТ!'}
          </div>
        </PixelButton>
      </div>
    </div>
  );
};
